import {
  ACTION_POST_REWARD_CONVERSION,
  ACTION_POST_REWARD_CONVERSION_SUCCESS,
  ACTION_POST_REWARD_CONVERSION_FAILURE,
  API_CALL,
} from '../../../configs/ActionTypes';
import { Dispatch } from 'redux';
import { enqueueSnackbarHandler } from '../../Status';
import { track } from '../../../analytics/analytics';

export type RewardConversionPayload = {
  effectiveDate?: string;
  startDate: string;
  endDate: string;
};

export function postRewardConversion(
  organizationId: string,
  data: RewardConversionPayload,
  onSuccess?: () => void,
  onFailure?: () => void,
) {
  return (dispatch: Dispatch) => {
    dispatch(requestStarted());

    dispatch({
      type: API_CALL,
      payload: {
        call: `organizations/${organizationId}/reward-conversion`,
        method: 'post',
        data: JSON.stringify(data),
        success: (response: any) => {
          if (response?.type === 'error') {
            enqueueSnackbarHandler(dispatch, response.payload, 'error');
            dispatch(requestFailed(response));
            onFailure?.();
            return;
          }

          enqueueSnackbarHandler(
            dispatch,
            { rewardConversionTriggered: true },
            'success',
          );
          dispatch(requestSuccess(response));
          track('BB_RewardProgramConverted', {
            organizationId,
            startDate: data.startDate,
            endDate: data.endDate,
          });
          onSuccess?.();
        },
        fail: (error: any) => {
          if (error?.payload) {
            enqueueSnackbarHandler(dispatch, error.payload, 'error');
          }
          dispatch(requestFailed(error));
          onFailure?.();
        },
      },
    });

    return null;
  };
}

export function requestStarted() {
  return {
    type: ACTION_POST_REWARD_CONVERSION,
    payload: null,
  };
}

export function requestSuccess(responseJSON: object) {
  return {
    type: ACTION_POST_REWARD_CONVERSION_SUCCESS,
    payload: responseJSON,
  };
}

export function requestFailed(responseJSON: object) {
  return {
    type: ACTION_POST_REWARD_CONVERSION_FAILURE,
    payload: responseJSON,
  };
}
